import type * as CSS from 'csstype'
import { system, Config } from '@styled-system/core'
import { ResponsiveValue } from '../utils/types'

export interface TouchableProps {
  /**
   * The cursor CSS property sets the type of cursor, if any, to show when the mouse pointer is over an element.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/CSS/cursor)
   */
  cursor?: ResponsiveValue<CSS.CursorProperty>
}

const config: Config = {
  cursor: true
}

export const touchableProps = system(config)
